import { graphql } from "gql.tada";
import { LinkFragment } from "../fragments/LinkFragment";
import { IconGridFragment } from "../fragments/IconGridFragment";
import { RichTextFragment } from "../fragments/RichTextFragment";

export const ColumnLegalSectionById = graphql(
  /* GraphQL */ `
    query ColumnLegalSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      columnLegalSection(id: $id, preview: $preview, locale: $locale) {
        _id
        leftColumnRichText {
          ...RichTextFragment
        }
        rightColumnRichText {
          ...RichTextFragment
        }
      }
    }
  `,
  [LinkFragment, IconGridFragment, RichTextFragment]
);
